/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { LogsSchemaEntry } from '../models/LogsSchemaEntry';

/**
* Response containing log schemas for all LLG resources in the project.
*/
export class LogsSchemasResponse {
  /**
  * The schema entries for each LLG resource.
  */
  'entries'?: Array<LogsSchemaEntry>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "entries",
      "baseName": "entries",
      "type": "Array<LogsSchemaEntry>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return LogsSchemasResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

